export const exploreJobPositionsQuery = `
    type SearchBarFilters {
        occupation_ids: [Int],
        domain_interest_ids: [String]
    }
    query explore_job_positions (
        $limit: Int!,
        $offset: Int!,
        $contract_type: [String],
        $lat: Float,
        $lon: Float,
        $radius: Float,
        $user_location_lat: Float,
        $user_location_lon: Float,
        $user_location_radius: Float,
        $min_salary: Int,
        $max_salary: String,
        $seasonal_job_position: Boolean,
        $salary_rating: [Int],
        $career_rating: [Int],
        $order_by: [String],
        $user_lat: Float,
        $user_lon: Float,
        $search_bar_filters: SearchBarFilters,
        $benefits: [String],
        $job_type: [String],
        $required_experience: String
        $occupation_id: Int,
        $domain_interest: [String],
        $occupation_ids: [String],
        $is_abroad_job: Boolean
    ) {
        explore_job_positions (
            limit: $limit,
            offset: $offset,
            contract_type: $contract_type,
            lat: $lat,
            lon: $lon,
            radius: $radius,
            user_location_lat: $user_location_lat,
            user_location_lon: $user_location_lon,
            user_location_radius: $user_location_radius,
            min_salary: $min_salary,
            max_salary: $max_salary,
            seasonal_job_position: $seasonal_job_position,
            salary_rating: $salary_rating,
            career_rating: $career_rating,
            order_by: $order_by,
            user_lat: $user_lat,
            user_lon: $user_lon,
            search_bar_filters: $search_bar_filters,
            benefits: $benefits,
            job_type: $job_type,
            required_experience: $required_experience
            occupation_id: $occupation_id,
            domain_interest: $domain_interest,
            occupation_ids: $occupation_ids,
            is_abroad_job: $is_abroad_job
        ) {
            data {
                id,
                job_title,
                max_salary,
                min_salary,
                salary,
                salary_type,
                salary_currency,
                salary_month_number,
                payment_type_var {
                    key
                },
                job_description,
                job_type_var {
                    label
                },
                occupation {
                    label_it {
                        label
                    }
                },
                published_at,
                semantic_unique_name,
                restaurant {
                    id,
                    locality,
                    restaurant_name,
                    restaurant_logo,
                    address,
                    pictures {
                        url,
                        order
                    }
                },
                show_restaurant_details
                already_applied
            },
            hits
        }
    }
`;

export const exploreStaticJobPositionsQuery = `
    query explore_static_job_positions (
        $occupation_id: Int,
        $restaurant_id: String,
        $employer_id: String
    ) {
        explore_static_job_positions (
            occupation_id: $occupation_id,
            restaurant_id: $restaurant_id,
            employer_id: $employer_id
        ) {
            id,
            job_title,
            max_salary,
            min_salary,
            salary,
            salary_type,
            salary_currency,
            salary_month_number,
            payment_type_var {
                key
            },
            job_description,
            job_type_var {
                label
            },
            occupation {
                label_it {
                    label
                }
            },
            semantic_unique_name,
            restaurant {
                id,
                locality,
                restaurant_name,
                restaurant_logo
            },
            show_restaurant_details
            published_at
        }
    }
`;

export const indexJobPositionsQuery = `
    query index_job_positions(
        $limit: Int!,
        $offset: Int!,
        $order_by: [String],
        $employer_id: String,
        $search_vector: String,
        $organization_id: String,
        $restaurant_name: [String],
        $status: String,
        $locality: [String],
        $occupation_id: String,
        $show_performance_metrics: Boolean
    ) {
        index_job_positions(
            limit: $limit,
            offset: $offset,
            order_by: $order_by,
            employer_id: $employer_id,
            search_vector: $search_vector,
            organization_id: $organization_id,
            restaurant_name: $restaurant_name,
            status: $status,
            locality: $locality,
            occupation_id: $occupation_id,
            show_performance_metrics: $show_performance_metrics
        ) {
            hits
            data {
                csm_list {
                    user_id,
                    icon_url,
                    name,
                    surname
                },
                number_of_interested_workers,
                number_of_active_shortlisted_workers,
                number_of_discarded_shortlisted_workers,
                number_of_hired_workers,
                number_of_shortlisted_workers,
                number_of_visits,
                number_of_workers_not_viewed_by_employer,
                all_time_number_of_interested_workers,
                applicants_avatar {
                    avatar_url,
                    name,
                    surname
                },
                job_position {
                    id,
                    published_at,
                    inserted_at,
                    last_status_change_date,
                    went_offline_at,
                    published_from_ats,
                    job_title,
                    semantic_unique_name,
                    requested_jr,
                    occupation {
                        domain_interest_var {
                          id,
                          key,
                          label
                        }
                        label_it {
                            label
                        }
                    },
                    next_task {
                        id,
                        due_date,
                        inserted_at
                    },
                    restaurant {
                        id,
                        employer_id,
                        restaurant_name,
                        restaurant_logo,
                        organization_id,
                        country
                    },
                    status_key,
                    ppu_paid_until,
                    ppu_offline_scheduled_at,
                    salary_type,
                    salary_ral,
                    salary_ral_min,
                    salary_ral_max,
                    salary_monthly_gross,
                    salary_monthly_gross_min,
                    salary_monthly_gross_max,
                    salary_hourly_gross,
                    salary_hourly_gross_min,
                    salary_hourly_gross_max,
                    status {
                      id,
                      key,
                      label,
                      level,
                      description,
                      sentiment
                  },
                  tasks {
                    id,
                    job_position_id,
                    due_date,
                    category,
                    sub_category,
                    description,
                    completed,
                    worker_ids,
                    rw_member {
                      user_id,
                      icon_url,
                      name,
                      surname,
                      roles {
                        id,
                        label,
                        key
                      }
                    },
                    sub_category_var {
                      label
                    },
                    category_var {
                      label
                    },
                    inserted_at
                  }
                }
            }
        }
    }
`;
